var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"d-flex"},'div',_vm.$attrs,false),[_c('div',{staticClass:"text--disabled cursor-help ml-1"},[_c('v-icon',{staticClass:"mb-1",attrs:{"small":"","lef":"","t":"","left":""}},[_vm._v("mdi-lightbulb-on-outline")]),(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }